import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  setPasswordBanner: {
    id: 'studio.bLt0wd',
    defaultMessage:
      'You have no active login methods. Please set a password or add a social login.',
  },
  setPasswordButton: {
    id: 'studio.Yy/yDL',
    defaultMessage: 'Reset password',
  },
  socialLoginButton: {
    id: 'studio.TUggpX',
    defaultMessage: 'Social login',
  },
});
